import {VALIDATE_INPUT} from '../actions'
import {PAYMENT_SUCCESS, PAYMENT_START} from '../shared/actions'
import some from 'lodash/some'
import mockData from "../mockData"

const initialState = window.data ? window.data : mockData

export const forms = (state = initialState, action) => {

    switch (action.type) {
        case VALIDATE_INPUT:

            const validations = state.validations || {}
            validations[action.payload.name] = action.payload.valid
            const hasErrors = some(validations, valid => !valid)
            return Object.assign({}, state, {
                validations,
                hasErrors
            })

        case PAYMENT_START:
            return Object.assign({}, state, {screen: "loading"})

        case PAYMENT_SUCCESS:
            const paymentResponse = {
              ...action.paymentResponse,
              paymentMethod: state.paymentData.paymentMethod,
              cardLogo: state.paymentData.cardLogo
            }
            let newState = {
                screen: action.screen,
                resultData: paymentResponse
            }
            return Object.assign({}, state, newState)


        default:
            return state
    }
}
